import { reduxType } from "../../interfaces/reducerType"
const defaultState: any = {
    id: "",
    record: [],
};
function reducer(state = defaultState, { type, payload }: reduxType) {
    switch (type) {
        case "setUserAddReg":
            return payload
        default:
            return state;
    }
}
export default reducer;